export const HOME_CATEGORY_PRODUCT_LIMIT = 20;

const getProductId = (product) => String(product?.id || product?._id || '');

export const prioritizeHomepageProducts = ({
  selectedIds = [],
  categoryProducts = [],
  productsById = new Map(),
  limit = HOME_CATEGORY_PRODUCT_LIMIT,
}) => {
  const prioritized = [];
  const seenIds = new Set();

  const addProduct = (product) => {
    const productId = getProductId(product);

    if (!productId || seenIds.has(productId)) {
      return;
    }

    seenIds.add(productId);
    prioritized.push(product);
  };

  selectedIds.forEach((productId) => addProduct(productsById.get(String(productId))));
  categoryProducts.forEach(addProduct);

  return prioritized.slice(0, limit);
};
